module.exports = __webpack_public_path__ + "static/media/cz.cf1119c6.svg";